import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  countCollectionPoints,
  CountCollectionPointsResponse,
} from '@/services/data-sources/count-collection-points';

interface UseCountCollectionPointsOptions extends Omit<
  UseQueryOptions<CountCollectionPointsResponse>,
  'queryKey' | 'queryFn'
> {
  collectionId?: string;
  externalId?: string;
  orgId?: string;
}

export const useCountCollectionPoints = (
  options?: UseCountCollectionPointsOptions,
) => {
  const { collectionId, externalId, orgId, ...queryOptions } = options || {};

  return useQuery<CountCollectionPointsResponse>({
    queryKey: ['collection-points-count', orgId, collectionId, externalId],
    queryFn: async () => {
      if (!collectionId || !externalId) {
        throw new Error('collectionId and externalId are required');
      }
      return countCollectionPoints({ collectionId, externalId });
    },
    enabled: !!collectionId && !!externalId && !!orgId,
    staleTime: 10 * 1000,
    ...queryOptions,
  });
};
